import { LitElement, html } from 'lit'
import { consume } from '@lit/context'
import { breakpointContext, navigationContext, isOutletNavigationOpenContext } from '../context.ts'
import { customElement } from 'lit/decorators.js'
import { TW, type Breakpoint, type MenuItem } from '../../../shared'

const TwLitElement = TW(LitElement)

/**
 * Sample Lit Element in assets/lit
 */
@customElement('desktop-top-level-nav')
export class DesktopTopLevelNav extends TwLitElement {

    @consume({context: navigationContext, subscribe: true}) 
    private _data: MenuItem[] = []

    @consume({context: breakpointContext, subscribe: true}) 
    private _breakpoint: Breakpoint | null = null

    @consume({context: isOutletNavigationOpenContext, subscribe: true})
    private _isOutletNavigationOpen: boolean = false

    private _isShown() 
    {
        return ! this._isOutletNavigationOpen && [ 'xl', '2xl', '3xl' ].includes( this._breakpoint?.name ?? '' ) // Wann soll die Navigation angezeigt werden?
    }

    render() 
    {
        if ( ! this._isShown() ) {
            return html``
        }

        return html`
            <nav aria-label="Hauptnavigation">
                <ul class="flex gap-6 -mb-.5 items-stretch">
                    ${this._data.filter( item => item.parentId === 0 ).map( item => html`
                        <li class="self-stretch py-4 border-b-4 border-solid ${item.active ? 'border-primary' : 'border-transparent'}">
                            <menu-item id=${item.id} 
                                class-default="font-medium" 
                                class-active="font-medium text-black"
                                also-toggle-sub-menu
                            ></menu-item>
                        </li>
                    `)}
                </ul>
            </nav>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'desktop-top-level-nav': DesktopTopLevelNav
    }
}
